var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          staticClass: "c-button",
          class: _vm.buttonClass,
          attrs: {
            to: _vm.to ? _vm.to : null,
            href: _vm.external && _vm.to,
            disabled: _vm.disabled || _vm.loading
          }
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._t("text-before"),
      _vm._v(" "),
      _vm.icon
        ? _c("c-icon", {
            staticClass: "icon",
            attrs: { icon: _vm.icon, size: _vm.fixedIconSize }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.loading
        ? _c("c-spinner", { staticClass: "loading", attrs: { size: "sm" } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3147d0c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3147d0c2","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CButton.vue
// module id = 2174
// module chunks = 1610